// ProtectedRoute.jsx
import Configs from '../Configs';

import { Navigate } from 'react-router-dom';
import { useAuth } from './appContext';
import { isDeniedByHrbpModuleGate } from './hrbpRouteModuleAccessGate';

// ----------------------------------------------------------------------
// ProtectedRoute component checks if the user is authenticated and has the required security levels
// If not, it redirects to the login page or unauthorized page
// ----------------------------------------------------------------------
function ProtectedRoute({ children, allowedRoles, hrbpModuleCode = null }) {
  const { authenticated, securityLevel, hrbpModuleAccess } = useAuth();

  if (Configs.devEnvironment)
    console.log(
      '[ProtectedRoute] authenticated: ',
      authenticated,
      ' securityLevel: ',
      securityLevel,
      ' allowedRoles: ',
      allowedRoles
    );

  // If the user is not authenticated, redirect to login
  if (!authenticated) {
    return <Navigate to="/" replace />; // or login page
  }

  // Ensure securityLevel is an array for comparison
  // Convert to numbers to handle string/number mismatches
  const securityLevelArray = Array.isArray(securityLevel)
    ? securityLevel
        .map((level) => (typeof level === 'string' ? parseInt(level, 10) : level))
        .filter((level) => !isNaN(level))
    : [securityLevel]
        .filter(Boolean)
        .map((level) => (typeof level === 'string' ? parseInt(level, 10) : level))
        .filter((level) => !isNaN(level));
  const allowedRolesArray = Array.isArray(allowedRoles)
    ? allowedRoles
        .map((role) => (typeof role === 'string' ? parseInt(role, 10) : role))
        .filter((role) => !isNaN(role))
    : [allowedRoles]
        .filter(Boolean)
        .map((role) => (typeof role === 'string' ? parseInt(role, 10) : role))
        .filter((role) => !isNaN(role));

  const hasAccess = securityLevelArray.some((level) => allowedRolesArray.includes(level));

  if (!hasAccess) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (
    isDeniedByHrbpModuleGate({
      allowedRolesArray,
      securityLevelArray,
      hrbpModuleCode,
      hrbpModuleAccess,
    })
  ) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}

// ----------------------------------------------------------------------
// Exporting the ProtectedRoute component
// ----------------------------------------------------------------------
export default ProtectedRoute;
